import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import cusBread from './components/cusBread'
// cusBread
Vue.config.productionTip = false

// siwper
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

Vue.component("cusBread",cusBread)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js